var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.destroy)?_c('div',{ref:"containes",staticClass:"skeleton"},[_c('div',{staticClass:"skeleton-remove-after-first-request"}),_c('div',{ref:"container",staticClass:"skeleton-container-remove-after-first-request"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }